import React from "react";
import styled from "styled-components";
import MenuLink from "../atoms/MenuLink";
import { color, font } from "../templates/ui";
import MenuItem from "../atoms/MenuItem";

const StyledMainMenu = styled.ul`
  display: ${props => (props.isOffCanvasMenu ? "block" : "none")};

  @media only screen and (min-width: 992px) {
    display: flex;
    justify-content: space-between;
  }
`;

// eslint-disable-next-line
const StyledMainMenuSecondLevel = styled.ul`
  padding-left: 6px;

  a {
    color: #5e5e5e;

    &:hover,
    &:focus {
        color: #E26E04;
      }
    }
  }
  
  @media only screen and (min-width: 992px) {
    position: absolute;
    background-color: white;
    padding: 15px;
    display: none;
    z-index: 1;
    
    a {
      padding: 7px 0;
    }
  }
`;

const StyledMenuItem = styled(MenuItem)`
  font-size: 1.6rem;
`;

const StyledLink = styled(MenuLink)`
  position: relative;
  overflow: hidden;
  height: ${props => {
    if (props.isOffCanvasMenu) {
      return "auto";
    }

    if (props.isChild) {
      return "auto";
    }

    return "70px";
  }};
  min-width: 60px;
  text-align: center;
  text-transform: uppercase;
  font-family: ${font.family.head};
  font-weight: 700;
  color: ${props => (props.isOffCanvasMenu ? `${color.black.base};` : `${color.base.base}`)};
`;

const StyledMenuItemKidsLogo = styled(MenuItem)`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 20px 0 10px;
  z-index: 0;
`;

const StyledLinkKidsLogo = styled(MenuLink)`
  position: relative;
  transition: transform ease-in-out 0.2s !important;
  background-image: url("/img/kids.svg");
  background-repeat: no-repeat;
  min-width: auto !important;
  width: 50px;
  height: 31px !important;
  overflow: hidden;
  padding: 0 !important;
  text-indent: -9999px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0);
  cursor: pointer;
  z-index: 1;

  &:hover,
  &:focus {
    transform: scale(1.05);
    &:before {
      transform: translateX(0);
    }
  }
`;

const MainMenu = ({ isOffCanvasMenu }) => (
  <StyledMainMenu isOffCanvasMenu={isOffCanvasMenu}>
    <StyledMenuItem>
      <StyledLink
        href="https://www.knhb.nl/spelregels-hockey"
        target="_blank"
        isMainMenuLink
        isOffCanvasMenu={isOffCanvasMenu}
      >
        Spelregels hockey
      </StyledLink>
    </StyledMenuItem>
    <MenuItem>
      <StyledLink
        href="https://www.knhb.nl/kenniscentrum"
        target="_blank"
        isMainMenuLink
        isOffCanvasMenu={isOffCanvasMenu}
      >
        Kenniscentrum
      </StyledLink>
    </MenuItem>
    <StyledMenuItem>
      <StyledLink
        href="https://www.knhb.nl/kenniscentrum/opleidingen"
        target="_blank"
        isMainMenuLink
        isOffCanvasMenu={isOffCanvasMenu}
      >
        Opleidingen
      </StyledLink>
    </StyledMenuItem>
    <MenuItem>
      <StyledLink href="https://www.knhb.nl/over-knhb" target="_blank" isMainMenuLink isOffCanvasMenu={isOffCanvasMenu}>
        Over KNHB
      </StyledLink>
    </MenuItem>
    <MenuItem>
      <StyledLink href="https://www.knhb.nl/agenda" target="_blank" isMainMenuLink isOffCanvasMenu={isOffCanvasMenu}>
        Agenda
      </StyledLink>
    </MenuItem>
    <MenuItem>
      <StyledLink href="https://www.knhb.nl/clubs" target="_blank" isMainMenuLink isOffCanvasMenu={isOffCanvasMenu}>
        Clubs
      </StyledLink>
    </MenuItem>
    <MenuItem>
      <StyledLink
        href="https://www.knhb.nl/match-center"
        target="_blank"
        isMainMenuLink
        isOffCanvasMenu={isOffCanvasMenu}
      >
        Match Center
      </StyledLink>
    </MenuItem>
    <StyledMenuItemKidsLogo>
      <StyledLinkKidsLogo
        href="https://www.knhb.nl/kids"
        target="_blank"
        isMainMenuLink
        isOffCanvasMenu={isOffCanvasMenu}
      >
        Kids
      </StyledLinkKidsLogo>
    </StyledMenuItemKidsLogo>
  </StyledMainMenu>
);

export default MainMenu;
